var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "drop-shadow afterSave",
      style: { border: "none" },
      attrs: { "max-width": _vm.screenUrl ? 1200 : 550 },
    },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.screenOnly ? _vm.$ct("screen-title") : _vm.$ct("title"))
        ),
      ]),
      _c(
        "w-card-content",
        { staticClass: "return-modal" },
        [
          _vm.screenUrl
            ? _c("iframe", {
                staticClass: "cashdro-screen",
                attrs: { src: _vm.screenUrl, title: "CashDro" },
              })
            : [
                _c(
                  "w-row",
                  { staticClass: "to-be-payed" },
                  [
                    _c("w-col", { attrs: { xs: "12", sm: "6" } }, [
                      _vm._v(_vm._s(_vm.$ct("to-be-payed"))),
                    ]),
                    _c("w-col", { attrs: { xs: "12", sm: "6" } }, [
                      _vm._v("€ " + _vm._s(_vm._f("humanFloat")(_vm.total))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c("w-col", { attrs: { xs: "12", sm: "6" } }, [
                      _vm._v(_vm._s(_vm.$ct("inserted-amount"))),
                    ]),
                    _c("w-col", { attrs: { xs: "12", sm: "6" } }, [
                      _vm._v("€ " + _vm._s(_vm._f("humanFloat")(_vm.payed))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c("w-col", { attrs: { xs: "12", sm: "6" } }, [
                      _vm._v(_vm._s(_vm.$ct("to-be-returned"))),
                    ]),
                    _c("w-col", { attrs: { xs: "12", sm: "6" } }, [
                      _vm._v("€ " + _vm._s(_vm._f("humanFloat")(_vm.returned))),
                    ]),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _vm.screenOnly
            ? _c(
                "w-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              )
            : _c(
                "w-button",
                {
                  staticClass: "cancel",
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("cancel-payment")))]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }